// extracted by mini-css-extract-plugin
export default {"spinner":"commonSpinner_spinner__BY76J"};